import React from 'react';

const Contact = () => {
    return (
        <div>
            <h3>this is contack page </h3>
        </div>
    );
};

export default Contact;